import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  agents: [],
};

const agentSlice = createSlice({
  name: 'agents',
  initialState,
  reducers: {
    setAgents: (state, action) => {
      state.agents = action.payload;
    },
  },
});

export const { setAgents } = agentSlice.actions;
export default agentSlice.reducer;
